import { useEffect, useState } from "react";
import type { Band } from "@/types";

export const hourToBand = (h: number): Band => {
  if (h >= 5 && h < 10) return "morning";
  if (h >= 10 && h < 17) return "midday";
  if (h >= 17 && h < 21) return "evening";
  return "night";
};

interface TimeOfDay {
  band: Band;
  hour: number;
  minute: number;
}

const compute = (): TimeOfDay => {
  const d = new Date();
  return {
    band: hourToBand(d.getHours()),
    hour: d.getHours(),
    minute: d.getMinutes(),
  };
};

export const useTimeOfDay = (): TimeOfDay => {
  const [state, setState] = useState<TimeOfDay>(compute);
  useEffect(() => {
    const id = window.setInterval(() => setState(compute()), 5 * 60 * 1000);
    return () => window.clearInterval(id);
  }, []);
  return state;
};
